import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISORSA_PNI } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlRisorsaPniState extends EntityState<IID_OL_RISORSA_PNI, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_RISORSA_PNI })
@InterfaceDataStore(InterfaceName.OLO_RISORSA_PNI)
export class IIDolRisorsaPniStore extends EntityStore<IIdOlRisorsaPniState> {
  constructor() {
    super([]);
  }
}
